import { makeStyles } from '@/ui/kit/styles/makeStyles'

export const useStyles = makeStyles()({
  root: {
    direction: 'rtl',
  },
  helper: {
    width: '100%',
    direction: 'ltr',
    whiteSpace: 'break-spaces',
  },
})
